/* This file is generated by the script. Do not modify it manually */

import type { CustomThemeConfig } from 'tailwindcss/types/config';

export const figmaTailwindTheme = {
  backgroundColor: ({ theme }) => ({
    ...theme('colors'),
    'element-secondary':
      'rgb(var(--semantic-colors-surface-element-secondary) / <alpha-value>)',
    'element-primary':
      'rgb(var(--semantic-colors-surface-element-primary) / <alpha-value>)',
    'element-negative':
      'rgb(var(--semantic-colors-surface-element-negative) / <alpha-value>)',
    plain: 'rgb(var(--semantic-colors-surface-plain) / <alpha-value>)',
    default: 'rgb(var(--semantic-colors-surface-default) / <alpha-value>)',
    contrast: 'rgb(var(--semantic-colors-surface-contrast) / <alpha-value>)',
    'status-success':
      'rgb(var(--semantic-colors-surface-status-success) / <alpha-value>)',
    'status-error':
      'rgb(var(--semantic-colors-surface-status-error) / <alpha-value>)',
    'status-info':
      'rgb(var(--semantic-colors-surface-status-info) / <alpha-value>)',
    'status-warning':
      'rgb(var(--semantic-colors-surface-status-warning) / <alpha-value>)',
    'status-disabled':
      'rgb(var(--semantic-colors-surface-status-disabled) / <alpha-value>)',
    'status-disabled-dark':
      'rgb(var(--semantic-colors-surface-status-disabled-dark) / <alpha-value>)',
    'status-selected':
      'rgb(var(--semantic-colors-surface-status-selected) / <alpha-value>)',
    brand: 'rgb(var(--semantic-colors-surface-brand) / <alpha-value>)',
    'colored-light':
      'rgb(var(--semantic-colors-surface-colored-light) / <alpha-value>)',
    colored: 'rgb(var(--semantic-colors-surface-colored) / <alpha-value>)',
    'colored-dark':
      'rgb(var(--semantic-colors-surface-colored-dark) / <alpha-value>)',
  }),
  borderColor: ({ theme }) => ({
    ...theme('colors'),
    default: 'rgb(var(--semantic-colors-border-default) / <alpha-value>)',
    contrast: 'rgb(var(--semantic-colors-border-contrast) / <alpha-value>)',
    'element-secondary':
      'rgb(var(--semantic-colors-border-element-secondary) / <alpha-value>)',
    'element-primary':
      'rgb(var(--semantic-colors-border-element-primary) / <alpha-value>)',
    'element-negative':
      'rgb(var(--semantic-colors-border-element-negative) / <alpha-value>)',
    plain: 'rgb(var(--semantic-colors-border-plain) / <alpha-value>)',
    'status-info':
      'rgb(var(--semantic-colors-border-status-info) / <alpha-value>)',
    'status-success':
      'rgb(var(--semantic-colors-border-status-success) / <alpha-value>)',
    'status-warning':
      'rgb(var(--semantic-colors-border-status-warning) / <alpha-value>)',
    'status-error':
      'rgb(var(--semantic-colors-border-status-error) / <alpha-value>)',
    'status-disabled':
      'rgb(var(--semantic-colors-border-status-disabled) / <alpha-value>)',
    'status-focused':
      'rgb(var(--semantic-colors-border-status-focused) / <alpha-value>)',
    'status-disabled-dark':
      'rgb(var(--semantic-colors-border-status-disabled-dark) / <alpha-value>)',
    'status-selected':
      'rgb(var(--semantic-colors-border-status-selected) / <alpha-value>)',
    brand: 'rgb(var(--semantic-colors-border-brand) / <alpha-value>)',
    divider: 'var(--semantic-colors-border-divider)',
  }),
  borderRadius: {
    none: 'var(--base-sizes-0)',
    xs: 'var(--base-sizes-0-5)',
    sm: 'var(--base-sizes-1)',
    DEFAULT: 'var(--base-sizes-1-5)',
    lg: 'var(--base-sizes-2)',
    xl: 'var(--base-sizes-4)',
    full: '9999px',
  },
  borderWidth: {
    none: 'var(--base-sizes-0)',
    DEFAULT: 'var(--base-sizes-1px)',
    lg: 'var(--base-sizes-0-5)',
    xl: 'var(--base-sizes-1)',
    'status-focused': 'var(--base-sizes-0-5)',
  },
  boxShadow: {
    xs: '0px 0px 1px 0px #00000033',
    'xs-hover': '0px 2px 1px 0px #00000033',
    'xs-press': '0px 0px 0px 0px #00000033',
    sm: '0px 1px 2px 1px #00000033',
    'sm-hover': '0px 4px 2px 1px #00000033',
    'sm-press': '0px 0px 1px 1px #00000033',
    'sm-reversed': '0px -1px 2px 1px #00000033',
    DEFAULT: '0px 2px 4px 1px #00000033',
    hover: '0px 6px 4px 1px #00000033',
    press: '0px 0px 2px 1px #00000033',
    reversed: '0px -2px 4px 1px #00000033',
    lg: '0px 4px 8px 1px #00000033',
    'lg-hover': '0px 8px 8px 1px #00000033',
    'lg-press': '0px 2px 4px 1px #00000033',
    'lg-reversed': '0px -4px 8px 1px #00000033',
    xl: '0px 6px 12px 1px #00000033',
    'xl-hover': '0px 10px 12px 1px #00000033',
    'xl-press': '0px 4px 8px 1px #00000033',
    'xl-reversed': '0px -6px 12px 1px #00000033',
    '2xl': '0px 8px 16px 1px #00000033',
    '2xl-hover': '0px 12px 16px 1px #00000033',
    '2xl-press': '0px 6px 12px 1px #00000033',
    '2xl-reversed': '0px -8px 16px 1px #00000033',
    '3xl': '0px 10px 20px 1px #00000033',
    '3xl-hover': '0px 14px 20px 1px #00000033',
    '3xl-press': '0px 8px 16px 1px #00000033',
    '3xl-reversed': '0px -10px 20px 1px #00000033',
  },
  colors: {
    'tint-10': 'var(--semantic-colors-tint-tint-10)',
    'tint-20': 'var(--semantic-colors-tint-tint-20)',
    'tint-30': 'var(--semantic-colors-tint-tint-30)',
    'tint-40': 'var(--semantic-colors-tint-tint-40)',
    'tint-50': 'var(--semantic-colors-tint-tint-50)',
    'tint-60': 'var(--semantic-colors-tint-tint-60)',
    'tint-70': 'var(--semantic-colors-tint-tint-70)',
    'tint-80': 'var(--semantic-colors-tint-tint-80)',
    'tint-90': 'var(--semantic-colors-tint-tint-90)',
    'tint-05': 'var(--semantic-colors-tint-tint-05)',
    'tint-15': 'var(--semantic-colors-tint-tint-15)',
    'tint-85': 'var(--semantic-colors-tint-tint-85)',
    'tint-95': 'var(--semantic-colors-tint-tint-95)',
    'shade-10': 'var(--semantic-colors-shade-shade-10)',
    'shade-20': 'var(--semantic-colors-shade-shade-20)',
    'shade-30': 'var(--semantic-colors-shade-shade-30)',
    'shade-40': 'var(--semantic-colors-shade-shade-40)',
    'shade-50': 'var(--semantic-colors-shade-shade-50)',
    'shade-60': 'var(--semantic-colors-shade-shade-60)',
    'shade-70': 'var(--semantic-colors-shade-shade-70)',
    'shade-80': 'var(--semantic-colors-shade-shade-80)',
    'shade-90': 'var(--semantic-colors-shade-shade-90)',
    'shade-05': 'var(--semantic-colors-shade-shade-05)',
    'shade-15': 'var(--semantic-colors-shade-shade-15)',
    'shade-85': 'var(--semantic-colors-shade-shade-85)',
    'shade-95': 'var(--semantic-colors-shade-shade-95)',
    hover: 'var(--semantic-colors-interaction-hover)',
    press: 'var(--semantic-colors-interaction-press)',
    'hover-inverted': 'var(--semantic-colors-interaction-hover-inverted)',
    'press-inverted': 'var(--semantic-colors-interaction-press-inverted)',
    'drop-shadow': 'var(--semantic-colors-interaction-drop-shadow)',
    overlay: 'var(--semantic-colors-interaction-overlay)',
    'element-on-secondary':
      'rgb(var(--semantic-colors-on-surface-element-on-secondary) / <alpha-value>)',
    'element-on-primary':
      'rgb(var(--semantic-colors-on-surface-element-on-primary) / <alpha-value>)',
    'element-on-negative':
      'rgb(var(--semantic-colors-on-surface-element-on-negative) / <alpha-value>)',
    'on-plain':
      'rgb(var(--semantic-colors-on-surface-on-plain) / <alpha-value>)',
    'status-on-info':
      'rgb(var(--semantic-colors-on-surface-status-on-info) / <alpha-value>)',
    'status-on-success':
      'rgb(var(--semantic-colors-on-surface-status-on-success) / <alpha-value>)',
    'status-on-warning':
      'rgb(var(--semantic-colors-on-surface-status-on-warning) / <alpha-value>)',
    'status-on-error':
      'rgb(var(--semantic-colors-on-surface-status-on-error) / <alpha-value>)',
    'status-on-selected':
      'rgb(var(--semantic-colors-on-surface-status-on-selected) / <alpha-value>)',
    'on-brand':
      'rgb(var(--semantic-colors-on-surface-on-brand) / <alpha-value>)',
    'on-colored-light':
      'rgb(var(--semantic-colors-on-surface-on-colored-light) / <alpha-value>)',
    'on-colored':
      'rgb(var(--semantic-colors-on-surface-on-colored) / <alpha-value>)',
    'on-colored-dark':
      'rgb(var(--semantic-colors-on-surface-on-colored-dark) / <alpha-value>)',
    'element-secondary':
      'rgb(var(--semantic-colors-surface-element-secondary) / <alpha-value>)',
    'element-primary':
      'rgb(var(--semantic-colors-surface-element-primary) / <alpha-value>)',
    'element-negative':
      'rgb(var(--semantic-colors-surface-element-negative) / <alpha-value>)',
    'status-success':
      'rgb(var(--semantic-colors-surface-status-success) / <alpha-value>)',
    'status-error':
      'rgb(var(--semantic-colors-surface-status-error) / <alpha-value>)',
    'status-info':
      'rgb(var(--semantic-colors-surface-status-info) / <alpha-value>)',
    'status-warning':
      'rgb(var(--semantic-colors-surface-status-warning) / <alpha-value>)',
    'status-disabled':
      'rgb(var(--semantic-colors-surface-status-disabled) / <alpha-value>)',
    'status-disabled-dark':
      'rgb(var(--semantic-colors-surface-status-disabled-dark) / <alpha-value>)',
    'status-selected':
      'rgb(var(--semantic-colors-surface-status-selected) / <alpha-value>)',
    brand: 'rgb(var(--semantic-colors-surface-brand) / <alpha-value>)',
    'colored-light':
      'rgb(var(--semantic-colors-surface-colored-light) / <alpha-value>)',
    colored: 'rgb(var(--semantic-colors-surface-colored) / <alpha-value>)',
    'colored-dark':
      'rgb(var(--semantic-colors-surface-colored-dark) / <alpha-value>)',
  },
  fontFamily: {
    sans: ['Source Sans Pro'],
    heading: ['Source Sans Pro'],
    iconRegular: ['Font Awesome 6 Pro'],
    iconSolid: ['Font Awesome 6 Pro'],
    iconDuotone: ['Font Awesome 6 Duotone'],
  },
  fontSize: {
    xs: ['0.75rem', '1rem'],
    sm: ['0.875rem', '1.25rem'],
    base: ['1rem', '1.5rem'],
    lg: ['1.125rem', '1.75rem'],
    'level-1': ['2.75rem', '3rem'],
    'level-2': ['2rem', '2rem'],
    'level-3': ['1.75rem', '2rem'],
    'level-4': ['1.5rem', '1.75rem'],
    'level-5': ['1.25rem', '1.5rem'],
    'level-6': ['1.125rem', '1.5rem'],
    'icon-2xs': ['0.625rem', '0.875rem'],
    'icon-xs': ['0.75rem', '1rem'],
    'icon-sm': ['0.875rem', '1.25rem'],
    'icon-base': ['1rem', '1.5rem'],
    'icon-lg': ['1.125rem', '1.75rem'],
    'icon-xl': ['1.25rem', '1.75rem'],
  },
  fontWeight: {
    regular: 'var(--base-font-weight-regular)',
    semibold: 'var(--base-font-weight-semibold)',
    bold: 'var(--base-font-weight-bold)',
  },
  gap: {
    none: 'var(--base-sizes-0)',
    '3xs': 'var(--base-sizes-1)',
    '2xs': 'var(--base-sizes-1-5)',
    xs: 'var(--base-sizes-2)',
    DEFAULT: 'var(--base-sizes-4)',
    lg: 'var(--base-sizes-5)',
    '4xs': 'var(--base-sizes-0-5)',
    xl: 'var(--base-sizes-6)',
    '2xl': 'var(--base-sizes-8)',
    sm: 'var(--base-sizes-3)',
  },
  margin: {
    none: 'var(--base-sizes-0)',
    '3xs': 'var(--base-sizes-1)',
    '2xs': 'var(--base-sizes-1-5)',
    xs: 'var(--base-sizes-2)',
    DEFAULT: 'var(--base-sizes-4)',
    lg: 'var(--base-sizes-5)',
    '4xs': 'var(--base-sizes-0-5)',
    xl: 'var(--base-sizes-6)',
    '2xl': 'var(--base-sizes-8)',
    sm: 'var(--base-sizes-3)',
  },
  padding: {
    none: 'var(--base-sizes-0)',
    '3xs': 'var(--base-sizes-1)',
    '2xs': 'var(--base-sizes-1-5)',
    xs: 'var(--base-sizes-2)',
    DEFAULT: 'var(--base-sizes-4)',
    lg: 'var(--base-sizes-5)',
    '4xs': 'var(--base-sizes-0-5)',
    xl: 'var(--base-sizes-6)',
    '2xl': 'var(--base-sizes-8)',
    sm: 'var(--base-sizes-3)',
  },
  ringColor: ({ theme }) => ({
    ...theme('colors'),
    DEFAULT: 'rgb(var(--semantic-colors-border-status-focused))',
  }),
  ringWidth: {
    DEFAULT: 'var(--base-sizes-0-5)',
  },
  spacing: {
    0: 'var(--base-sizes-0)',
    1: 'var(--base-sizes-1)',
    2: 'var(--base-sizes-2)',
    3: 'var(--base-sizes-3)',
    4: 'var(--base-sizes-4)',
    5: 'var(--base-sizes-5)',
    6: 'var(--base-sizes-6)',
    7: 'var(--base-sizes-7)',
    8: 'var(--base-sizes-8)',
    9: 'var(--base-sizes-9)',
    10: 'var(--base-sizes-10)',
    11: 'var(--base-sizes-11)',
    12: 'var(--base-sizes-12)',
    14: 'var(--base-sizes-14)',
    16: 'var(--base-sizes-16)',
    20: 'var(--base-sizes-20)',
    '1px': 'var(--base-sizes-1px)',
    0.5: 'var(--base-sizes-0-5)',
    1.5: 'var(--base-sizes-1-5)',
    2.5: 'var(--base-sizes-2-5)',
    3.5: 'var(--base-sizes-3-5)',
    4.5: 'var(--base-sizes-4-5)',
    'content-default': '960px',
  },
  textColor: ({ theme }) => ({
    ...theme('colors'),
    default: 'rgb(var(--semantic-colors-text-default) / <alpha-value>)',
    'element-secondary':
      'rgb(var(--semantic-colors-text-element-secondary) / <alpha-value>)',
    'element-primary':
      'rgb(var(--semantic-colors-text-element-primary) / <alpha-value>)',
    'element-negative':
      'rgb(var(--semantic-colors-text-element-negative) / <alpha-value>)',
    'status-info':
      'rgb(var(--semantic-colors-text-status-info) / <alpha-value>)',
    'status-success':
      'rgb(var(--semantic-colors-text-status-success) / <alpha-value>)',
    'status-disabled-dark':
      'rgb(var(--semantic-colors-text-status-disabled-dark) / <alpha-value>)',
    'status-warning':
      'rgb(var(--semantic-colors-text-status-warning) / <alpha-value>)',
    'status-error':
      'rgb(var(--semantic-colors-text-status-error) / <alpha-value>)',
    'status-disabled':
      'rgb(var(--semantic-colors-text-status-disabled) / <alpha-value>)',
    'status-selected':
      'rgb(var(--semantic-colors-text-status-selected) / <alpha-value>)',
    contrast: 'rgb(var(--semantic-colors-text-contrast) / <alpha-value>)',
    brand: 'rgb(var(--semantic-colors-text-brand) / <alpha-value>)',
    plain: 'rgb(var(--semantic-colors-text-plain) / <alpha-value>)',
  }),
  screens: {
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1408px',
    '2xl': '1600px',
    xs: '480px',
  },
} satisfies Partial<CustomThemeConfig & { extend: Partial<CustomThemeConfig> }>;
